/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './gluco-user.reducer';

export const GlucoUser = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const glucoUserList = useAppSelector(state => state.glucoUser.entities);
  const loading = useAppSelector(state => state.glucoUser.loading);
  const totalItems = useAppSelector(state => state.glucoUser.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="gluco-user-heading" data-cy="GlucoUserHeading">
        <Translate contentKey="tinyMedicRestApp.glucoUser.home.title">Gluco Users</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.glucoUser.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/gluco-user/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.glucoUser.home.createLabel">Create new Gluco User</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.glucoUser.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {glucoUserList && glucoUserList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('age')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.age">Age</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('age')} />
                </th>
                <th className="hand" onClick={sort('country')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.country">Country</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('country')} />
                </th>
                <th className="hand" onClick={sort('customRangeMax')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.customRangeMax">Custom Range Max</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('customRangeMax')} />
                </th>
                <th className="hand" onClick={sort('customRangeMin')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.customRangeMin">Custom Range Min</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('customRangeMin')} />
                </th>
                <th className="hand" onClick={sort('typeOfDiabeties')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.typeOfDiabeties">Type Of Diabeties</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('typeOfDiabeties')} />
                </th>
                <th className="hand" onClick={sort('gender')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.gender">Gender</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('gender')} />
                </th>
                <th className="hand" onClick={sort('height')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.height">Height</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('height')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('mobile')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.mobile">Mobile</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mobile')} />
                </th>
                <th className="hand" onClick={sort('name')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.name">Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('name')} />
                </th>
                <th className="hand" onClick={sort('tmPassword')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.tmPassword">Tm Password</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tmPassword')} />
                </th>
                <th className="hand" onClick={sort('preferredGlucoseUnit')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.preferredGlucoseUnit">Preferred Glucose Unit</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('preferredGlucoseUnit')} />
                </th>
                <th className="hand" onClick={sort('preferredLanguage')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.preferredLanguage">Preferred Language</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('preferredLanguage')} />
                </th>
                <th className="hand" onClick={sort('preferredRange')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.preferredRange">Preferred Range</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('preferredRange')} />
                </th>
                <th className="hand" onClick={sort('preferredUnitA1c')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.preferredUnitA1c">Preferred Unit A 1 C</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('preferredUnitA1c')} />
                </th>
                <th className="hand" onClick={sort('preferredUnitWeight')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.preferredUnitWeight">Preferred Unit Weight</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('preferredUnitWeight')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('parent')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.parent">Parent</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('parent')} />
                </th>
                <th className="hand" onClick={sort('dateOfBirth')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.dateOfBirth">Date Of Birth</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dateOfBirth')} />
                </th>
                <th className="hand" onClick={sort('uuid')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.uuid">Uuid</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('uuid')} />
                </th>
                <th className="hand" onClick={sort('bloodGroup')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.bloodGroup">Blood Group</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bloodGroup')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('imported')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.imported">Imported</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('imported')} />
                </th>
                <th className="hand" onClick={sort('deceased')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.deceased">Deceased</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('deceased')} />
                </th>
                <th className="hand" onClick={sort('deceasedDate')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.deceasedDate">Deceased Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('deceasedDate')} />
                </th>
                <th className="hand" onClick={sort('deceasedReason')}>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.deceasedReason">Deceased Reason</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('deceasedReason')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.contactDetails">Contact Details</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.glucoUser.tmUser">Tm User</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {glucoUserList.map((glucoUser, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/gluco-user/${glucoUser.id}`} color="link" size="sm">
                      {glucoUser.id}
                    </Button>
                  </td>
                  <td>{glucoUser.active ? 'true' : 'false'}</td>
                  <td>{glucoUser.age}</td>
                  <td>{glucoUser.country}</td>
                  <td>{glucoUser.customRangeMax}</td>
                  <td>{glucoUser.customRangeMin}</td>
                  <td>{glucoUser.typeOfDiabeties}</td>
                  <td>{glucoUser.gender}</td>
                  <td>{glucoUser.height}</td>
                  <td>{glucoUser.microSec}</td>
                  <td>{glucoUser.mobile}</td>
                  <td>{glucoUser.name}</td>
                  <td>{glucoUser.tmPassword}</td>
                  <td>{glucoUser.preferredGlucoseUnit}</td>
                  <td>{glucoUser.preferredLanguage}</td>
                  <td>{glucoUser.preferredRange}</td>
                  <td>{glucoUser.preferredUnitA1c}</td>
                  <td>{glucoUser.preferredUnitWeight}</td>
                  <td>{glucoUser.timestampentry}</td>
                  <td>{glucoUser.parent ? 'true' : 'false'}</td>
                  <td>{glucoUser.dateOfBirth}</td>
                  <td>{glucoUser.uuid}</td>
                  <td>{glucoUser.bloodGroup}</td>
                  <td>{glucoUser.lastupdated}</td>
                  <td>{glucoUser.cursor}</td>
                  <td>{glucoUser.imported ? 'true' : 'false'}</td>
                  <td>{glucoUser.deceased ? 'true' : 'false'}</td>
                  <td>{glucoUser.deceasedDate}</td>
                  <td>{glucoUser.deceasedReason}</td>
                  <td>
                    {glucoUser.contactDetails ? (
                      <Link to={`/contact-details/${glucoUser.contactDetails.id}`}>{glucoUser.contactDetails.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{glucoUser.tmUser ? glucoUser.tmUser.id : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/gluco-user/${glucoUser.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/gluco-user/${glucoUser.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/gluco-user/${glucoUser.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.glucoUser.home.notFound">No Gluco Users found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={glucoUserList && glucoUserList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default GlucoUser;
